// ResourceSection1.jsx

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import resourcesData from "./Resources.json";
import "./Resources.css";

const ResourceSection1 = () => {
  const [activeTab, setActiveTab] = useState("Blogs");
  const navigate = useNavigate();

  const tabs = ["Blogs", "Case Study"];

  const makeSlug = (title) => {
    return title.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  };

  const handleCardClick = (item) => {
    if (activeTab === "Blogs") {
      navigate(`/blogs/${makeSlug(item.title)}`);
    } else {
      navigate(`/case-study/${makeSlug(item.title)}`);
    }
  };

  return (
    <section className="backdiv">
      <div>
        <h2 className="main-title">Resources</h2>

        <div className="resource-tabs">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={activeTab === tab ? "tab-btn active" : "tab-btn"}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="resource-grid">
          {resourcesData[activeTab].map((item, index) => (
            <div
              className="resource-card"
              key={index}
              onClick={() => handleCardClick(item)}
            >
              <div className="resource-content">
              <div className="arrow-icon">↗</div>
              <h3 className="resource-title">{item.title}</h3>
              <p className="resource-desc">{item.desc}</p>
              </div>
              <div className="resource-img">
              <img src={item.img} alt={item.title} loading="lazy" className="cover-img"/>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResourceSection1;